"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const User = __importStar(require("../../../../../../user"));
const openapi_1 = require("../../../../../openapi");
const Consumable = __importStar(require("../../device/consumable/schema"));
const Factory = __importStar(require("../../device/factory/schema"));
const Log = __importStar(require("../../device/log/schema"));
const Stats = __importStar(require("../../device/stats/schema"));
const Schema = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Admin.Device.Spec';
const Role = User.GlobalUserRole.enums;
/** `read`: the admin-device read guard. The body is the v1 `{ message }` 401/403. */
const withRead = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager, Role.BrandSupportOperator, Role.BrandTechOperator, Role.Dealer, Role.DealerTechnician);
/** `write`: sysAdmin, admin and brandManager. */
const withWrite = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager);
/**
 * Every alias except factory inventory loads the device with `buildStaticDeviceSession`
 * before calling the shared handler.
 */
const DEVICE = 'serialNumber is taken from the query when that key is present, including an empty value. The body is used only when the key is absent. ' +
    'The session is the raw device document. A database error during that load is the v1 500 on every alias, before the handler runs. ' +
    'A missing document makes getDevice() throw NOT_ALLOWED. The route turns an uncaught throw into the v1 500.';
const MALFORMED_JSON = 'Malformed JSON is the Express default HTML 400: express.json() is attached on the route, ' +
    'and the JSON error handler runs before the routes.';
const Empty = openapi_1.Response.EmptyData.annotations({
    description: 'v1 success with data: {}',
});
const postFactoryInventory = platform_1.HttpApiEndpoint.post('setFactoryInventory') `/factory/inventory`
    .setPayload(Factory.RegistryInfoPayload)
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(Schema.InvalidSerialNumber)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Set factory inventory')
    .annotate(platform_1.OpenApi.Description, 'Stores factory registry information for a device. This is the factory registry handler, and the caller session is ignored. ' +
    'There is no factory key: the guard is the admin write role. A known serial replaces a stored value only when the new one is non-empty and keeps the rest. An empty string counts as not supplied. ' +
    'The handler passes the formatted device to update(), and that record has no providedLocation, so a known serial always gets ' +
    'providedLocation: {} and loses its stored coordinates. The domain schema rejects {}, so a later V2 read of that device is 500 ' +
    'and a list query drops it. An unknown serial is registered, with its model taken from the serial, and an omitted value stored as null. ' +
    'A body that parses but fails validation is 422 INVALID_REQUEST with inputValidation. A new serial that encodes no model is 422 ' +
    'INVALID_SERIAL_NUMBER. A failed registry write is 500. ' +
    MALFORMED_JSON)
    .pipe(withWrite);
const postFactoryReset = platform_1.HttpApiEndpoint.post('factoryReset') `/factory/reset`
    .setUrlParams(Schema.SerialQuery)
    .setPayload(Schema.SerialBody)
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1NotAuthenticated)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Factory reset')
    .annotate(platform_1.OpenApi.Description, 'Resets the device to factory settings and dismisses open alarms. This is the service-menu factory reset. ' +
    DEVICE +
    ' A missing document is 401. A failed reset is 500. The success body is data: {}. ' +
    'The body is not validated. It may be empty when serialNumber is in the query. ' +
    MALFORMED_JSON)
    .pipe(withWrite);
const getCatalog = platform_1.HttpApiEndpoint.get('getConsumableCatalog') `/consumables/catalog`
    .setUrlParams(Schema.CatalogQuery)
    .addSuccess(openapi_1.Response.Success(Schema.CatalogResult))
    .addError(openapi_1.Error.Internal)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get consumable catalog')
    .annotate(platform_1.OpenApi.Description, 'Returns a consumable catalog for the device named by serialNumber. ' +
    DEVICE +
    ' An absent legacyOutput, an empty string, or the string false returns the v2 catalogue. Any other value, including true and 1, ' +
    'returns the legacy catalog: the query is otherwise ignored, the list is not filtered by model, and six tags are kept ' +
    '(LiquidEnhancement, PreCarbonBlockFilter, CarbonBlockFilter, LimescaleFilter, UVCLight, CO2Tank). That path does not call ' +
    'getDevice(), so a missing serial still returns the catalog. The v2 catalogue is for the model on the session device. A session failure, a device that does not decode, ' +
    'or a catalogue that does not encode is the v2 500. There is no 422.')
    .pipe(withRead);
const getInstalled = platform_1.HttpApiEndpoint.get('getInstalledConsumables') `/consumables/installed`
    .setUrlParams(Schema.SerialQuery)
    .addSuccess(openapi_1.Response.Success(Consumable.Installed))
    .addError(Consumable.Pelican2Only)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get installed consumables')
    .annotate(platform_1.OpenApi.Description, 'Returns the Pelican2 slots in the legacy shape. ' +
    DEVICE +
    ' When the document does not decode, a Pelican2 model is 500 and any other model is 422 INVALID_REQUEST, with detail naming ' +
    'that model. A MicroPurityFilter in slot 9 has no legacy mapping, so that device is 500. ' +
    'A missing document throws before a response and is the v1 500.')
    .pipe(withRead);
const patchConsumable = platform_1.HttpApiEndpoint.patch('patchConsumable') `/consumable`
    .setUrlParams(Schema.SerialQuery)
    .setPayload(Schema.ConsumablePatch)
    .addSuccess(openapi_1.Response.Success(Consumable.InstalledList))
    .addError(Consumable.PatchRejected)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update consumables')
    .annotate(platform_1.OpenApi.Description, 'Updates Pelican2 slots. serialNumber is removed from the body, and a body with items is replaced by that value, ' +
    'before the service-menu patch decodes one instruction or an array of them. ' +
    DEVICE +
    ' A body that parses but does not decode is 400 BAD_REQUEST with validationErrors. The success body is the legacy slot list, ' +
    'not wrapped in items. The device is saved before that list is built. A MicroPurityFilter in slot 9 has no legacy mapping, ' +
    'so the mapper throws after the save: the client gets 500 and the write is already stored. An unknown subsetId, or a subset ' +
    'whose tag the slot does not accept, throws during the slot update, before the save, so nothing is stored. A device that is ' +
    'not a Pelican2, or a missing document, rejects before the save and is 500. ' +
    MALFORMED_JSON)
    .pipe(withWrite, openapi_1.Annotations.deprecated());
const patchAddress = platform_1.HttpApiEndpoint.patch('patchInstallationAddress') `/location/address`
    .setUrlParams(Schema.SerialQuery)
    .setPayload(Schema.AddressPatch)
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthenticated)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update installation address')
    .annotate(platform_1.OpenApi.Description, 'Updates the installation address. This is the service-menu address handler. ' +
    DEVICE +
    ' lat and lon are both kept only when both are sent. If either is missing, formatLatLon fills both from the address and ' +
    'overwrites the one that was sent. A failed lookup is swallowed and both are set to null; it is not 500. update() then skips ' +
    'a null or zero coordinate, because the check is if (lat) and if (lon), and an omitted or empty address or contact field keeps the stored value. mobilePhoneNumber is written into ' +
    'phoneNumber when phoneNumber is omitted. A supplied customerAccountId is spread into numeric keys and is not stored under that ' +
    'name, because || is evaluated before the object that would store it. The request still returns 200, and that contactInfo replaces ' +
    'the stored one, so a previously stored account id is lost. update() sets providedLocation from the raw session device, or to {} ' +
    'when that device has none. A body that parses but fails validation is 422: isFloat or isString failed. A missing document is 401. ' +
    'A registry failure is 500. ' +
    MALFORMED_JSON)
    .pipe(withWrite);
const patchCellTower = platform_1.HttpApiEndpoint.patch('patchCellTower') `/location/cell-tower`
    .setUrlParams(Schema.SerialQuery)
    .setPayload(Schema.CellTowerPatch)
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthenticated)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update cell tower location')
    .annotate(platform_1.OpenApi.Description, 'Writes detectedLocation from cellTowerInfo and returns data: {}. This is the service-menu cell-tower handler. ' +
    DEVICE +
    ' notEmpty() stringifies an object, so {} passes and is forwarded. The stored value is { lat, lon, accuracy, source: "CELL" }: ' +
    'numbers when Google returns a fix, and null for all three when the lookup fails, including the empty object. The lookup failure ' +
    'is still 200. Either shape uses source, and the domain detected location expects tech, so a later V2 read of that device is 500 ' +
    'and a list query drops it. A body that parses but fails validation is 422: cellTowerInfo is missing or is not an object. A missing document is 401. ' +
    'A registry write failure is 500. ' +
    MALFORMED_JSON)
    .pipe(withWrite);
const getEvents = platform_1.HttpApiEndpoint.get('getDeviceEvents') `/log/events`
    .setUrlParams(Schema.SerialQuery)
    .addSuccess(openapi_1.Response.Success(Log.Events))
    .addError(openapi_1.Error.V1Forbidden)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get device events')
    .annotate(platform_1.OpenApi.Description, 'Returns stored history events. ' +
    DEVICE +
    ' The window is createdAt from 30 days before now through now. The body is { items: rows }, and Cosmos system fields are removed. ' +
    'A missing document is 403 NOT_ALLOWED. Any other failure in the catch is 500.')
    .pipe(withRead);
const getAlarms = platform_1.HttpApiEndpoint.get('getDeviceAlarms') `/log/alarms`
    .setUrlParams(Schema.SerialQuery)
    .addSuccess(openapi_1.Response.Success(Schema.AlarmRows))
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get device alarms')
    .annotate(platform_1.OpenApi.Description, 'Returns the alarm rows for the last 30 days, at most 100, including orphans. The log handler returns a page ' +
    "({ itemsCount, pagesCount, page, items }) under data.items. This route replaces data.items with that page's items, " +
    'so data.items is the row array and the page fields are dropped. Each row is the stored alarm: name and params, ' +
    'not a nested alarm. ' +
    DEVICE +
    " The replacement always reads data.items.items. An error body has no data, so the log handler's 403 or 500 throws here " +
    'and the client gets the v1 500.')
    .pipe(withRead);
const getStats = platform_1.HttpApiEndpoint.get('getEnhancedDrinkStats') `/stats`
    .setUrlParams(Schema.SerialQuery)
    .addSuccess(openapi_1.Response.Success(Stats.EnhancedDrinks))
    .addError(openapi_1.Error.V1Forbidden)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get enhanced drink stats')
    .annotate(platform_1.OpenApi.Description, 'Returns how many drinkDispensed events had comp.enhanced set, and a count per subset id. ' +
    DEVICE +
    ' The subset count is the number of entries in params.enhancements, so one event can add more than one, and an entry without ' +
    'subsetId is counted as "undefined". The counts are data itself, not data.items. A missing document is 403 NOT_ALLOWED. ' +
    'An event with no params, or any other failure in the catch, is 500.')
    .pipe(withRead);
exports.Spec = platform_1.HttpApiGroup.make('v2.admin.device')
    .add(postFactoryInventory)
    .add(postFactoryReset)
    .add(getCatalog)
    .add(getInstalled)
    .add(patchConsumable)
    .add(patchAddress)
    .add(patchCellTower)
    .add(getEvents)
    .add(getAlarms)
    .add(getStats)
    .prefix('/admin/device')
    .annotate(platform_1.OpenApi.Title, 'Admin device')
    .annotate(platform_1.OpenApi.Description, 'Admin aliases of the device service menu and the factory registry. Each route names the device by serialNumber.')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map